import { IUpdateDiarioObraAtividadeUseCase } from "../../../presentation/useCases/update/update_diario_obras_atividades_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// UpdateDiarioObraAtividadesUseCase


export class UpdateDiarioObraAtividadesUseCase implements IUpdateDiarioObraAtividadeUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async updateDiarioObraAtividade(  IdDiarioObrasAtividades: number, IdDiarioObras: number | null, Descricao: string | null, IdFornecedor: number | null, TipoMaoDeObra: number | null, Ordem: number | null): Promise<void> {
    
    await this.repository.updateDiarioObraAtividade(
        IdDiarioObrasAtividades, IdDiarioObras, Descricao, IdFornecedor, TipoMaoDeObra, Ordem
    );
  }
}
